/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import React, { useCallback } from 'react';
import { Formik, Form } from 'formik';
import { withFormikDevtools } from 'formik-devtools-extension';
import FormikInput from 'src/components/formik/FormikInput';
import { useHistory } from 'react-router-dom';
import RoutingUtil from 'src/utils/RoutingUtil';
import { isProduction } from 'src/config/index';
import RemarkComponent from 'src/containers/remarks-container/RemarkContainer';
import FormikToggle from 'src/components/formik/FormikToggle';
import FormikCreateSearchClear from 'src/components/formik/FormikCreateSearchClear';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { includeStamp } from 'src/utils/StampUtils';
import FormikSelect from 'src/components/formik/FormikSelect';
import { productResetAction, productUpsertAction } from './actions/ProductActions';
import { ProductYupSchema } from './ProductPropTypes';
import ProductMetaFactory from './factory/ProductMetaFactory';
import { PRODUCT_CATEGORY_TYPES_LIST } from './ProductConstants';

const Render = (props) => {
    const {
        values,
        // errors,
        // touched,
        isSubmitting,
        onSearch,
        onClear,
        resetForm,
    } = props;

    // DEV TOOL
    if (!isProduction()) {
        withFormikDevtools(props);
    }

    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">Product Details</h5>
                <Form autoComplete="disabled">

                    <div className="form-row">
                        <div className="form-group col">
                            <FormikToggle name="active" />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Product Name</label>
                            <FormikInput
                                name="productName"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Category</label>
                            <FormikSelect
                                items={PRODUCT_CATEGORY_TYPES_LIST}
                                name="category"
                                className="form-control"
                                disabled={values._id}
                            />
                        </div>
                    </div>

                    <ProductMetaFactory
                        values={values}
                        category={values.category}
                    />

                    <div className="text-center py-4 mt-3">
                        <FormikCreateSearchClear
                            isSubmitting={isSubmitting}
                            isUpdate={Boolean(values._id)}
                            onSearch={onSearch}
                            onClear={onClear}
                            resetForm={resetForm}
                            values={values}
                            submitScope="master.product_manager.manage.submit"
                            searchScope="master.product_manager.manage.search"
                        />
                    </div>
                </Form>

                <div className="form-group">
                    <RemarkComponent
                        title="Product Remarks"
                        refId={values._id}
                        source="products"
                    />
                </div>
            </div>
        </div>
    );
};

Render.propTypes = {
    isSubmitting: PropTypes.bool.isRequired,
    onSearch: PropTypes.func.isRequired,
    onClear: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    values: PropTypes.shape({
        _id: PropTypes.string,
        category: PropTypes.string,
    }).isRequired,
};

// setting submit button state after submitting
let setSubmitting = () => {};

const ProductForm = () => {
    const history = useHistory();
    // REDUX
    const dispatch = useDispatch();
    const {
        currentRecord,
        upsertReqStatus,
    } = useSelector((state) => state.ProductReducer, shallowEqual);

    // if current record changed or request status changed the enable submit
    usePrevious({
        currentRecord,
        upsertReqStatus,
    }, (prev) => {
        if (
            prev.currentRecord !== currentRecord
                || (upsertReqStatus && prev.upsertReqStatus !== upsertReqStatus && upsertReqStatus !== REQUEST_STATUS.PENDING)) {
            setSubmitting(false);
        }
    });

    const onSubmit = useCallback((
        values,
        formikUtils,
    ) => {
        ({ setSubmitting } = formikUtils);
        includeStamp(values);
        dispatch(productUpsertAction(values));
    }, [
        dispatch,
    ]);

    const onSearch = useCallback((values) => {
        const {
            productName,
            active,
            category,
            meta,
        } = values;

        // search include all meta keys
        const metaSearchStrings = {};
        for (const key in meta || {}) {
            if (Object.hasOwnProperty.call(meta, key)) {
                metaSearchStrings[`meta.${key}`] = meta[key];
            }
        }

        history.push(RoutingUtil.productSearch({
            productName,
            category,
            active,
            ...metaSearchStrings,
        }));
    }, [
        history,
    ]);

    const onClear = useCallback(() => {
        dispatch(productResetAction());
    }, [
        dispatch,
    ]);

    return (
        <Formik
            onSubmit={onSubmit}
            onClear={onClear}
            enableReinitialize
            initialValues={currentRecord}
            validationSchema={ProductYupSchema}
            onSearch={onSearch}
        >
            {(formikProps) => (
                <Render
                    onClear={onClear}
                    onSearch={onSearch}
                    {...formikProps}
                />
            )}
        </Formik>
    );
};

export default ProductForm;
